import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
    selector: 'app-usage-policy',
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    templateUrl: './usage-policy.page.html',
    styleUrls: ['./usage-policy.page.scss'],
})
export class UsagePolicyPage { }
